import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import CalculadoraFlutuante from "./CalculadoraFlutuante";
import ConversasFlutuantes from "./ConversaFlutuante";

// Tudo que flutua por cima do sistema (só para quem está logado).
const Flutuantes = () => {
  const { user } = useContext(AuthContext);
  if (!user?.id) return null;
  return (
    <>
      <ConversasFlutuantes />
      <CalculadoraFlutuante />
    </>
  );
};

export default Flutuantes;
